import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;
  margin: 0 auto;
  padding: 1rem 0;

  .inner {
    display: block;
  }
`;

const StyledText = styled.div`
  width: 100%;

  p {
    width: 80%;
    margin-bottom: 20px;
    line-height: 1.5;
    
  }

  ul.skills-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(140px, 200px));
  gap: 0 10rem;
  padding: 0;
  margin: 1rem 0 0 0;
  list-style: none;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.5rem 0;
  }

  li {
    position: relative;
    margin-bottom: 1rem;
    padding-left: 1.5rem;
    width: 20rem;
    font-family: var(--font-mono);
    font-size: var(--fz-xs);

    @media (max-width: 768px) {
    width: 100%;
  }

    &:before {
      content: '▹';
      position: absolute;
      left: 0;
      color: var(--green);
      font-size: var(--fz-sm);
      line-height: 12px;
    }
  }
}

`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, [prefersReducedMotion]);

  const skills = [
    'Rust, C/C++, Python, TypeScript',
    'Ethereum, Solana, Polkadot/Substrate',
    'Zero-Knowledge Proofs, Noir, Circom',
    'FHE, HElib, RISC Zero',
    'AWS, GCP, Terraform, Docker, Kubernetes',
    'Grafana, Loki, Prometheus, CI/CD',
  ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <p>
            I'm a senior software engineer focused on low-latency backend, blockchain, and full-stack systems. My work spans production services, developer tooling, monitoring systems, and CI/CD workflows across startup, enterprise engineering, and education environments.
          </p>
          <p>
            Recently, I've worked on Ethereum PBS/block-builder infrastructure, Solana arbitrage microservices, real-time data systems, cryptography research, and technical excellence programs for software engineers. I care about performance, reliability, and user-facing impact.
          </p>
          <p>
            Some technologies I've been working with recently include:
          </p>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>
      </div>
    </StyledAboutSection>
  );
};

export default About;
